import { Component, Input, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ModalDirective, ModalModule } from 'ngx-bootstrap/modal';
import { ApiCollectionsService } from '../../../../../services/collections/api/api-collections.service';
import { AlertsService } from '../../../../../services/alerts.service';
import { LanguagesService } from '../../../../../services/languages/languages.service';
import { CollectionCard } from '../../../../../models/collections/collection-card.model';
import { CollectionCardRankType } from '../../../../../enums/collections/collection-card-rank-type.enum';
import { CollectionTranslationForm, buildCollectionTranslationForms, toCollectionTranslations } from '../../../collection-translation-form.model';

@Component({
  selector: 'app-collection-card-edit-modal',
  templateUrl: './collection-card-edit-modal.component.html',
  standalone: true,
  imports: [ModalModule, CommonModule, FormsModule]
})
export class CollectionCardEditModalComponent {

  @Input() albumId: number = 0;

  @ViewChild('modal') modal!: ModalDirective;

  readonly rankTypes = Object.entries(CollectionCardRankType).filter(([, v]) => typeof v === 'number') as [string, number][];

  isLoading: boolean = false;
  cardId: number = 0;
  name: string = '';
  rankType: CollectionCardRankType = CollectionCardRankType.None;
  translations: CollectionTranslationForm[] = [];

  private callbackSaved?: () => void;

  constructor(
    private apiCollectionsService: ApiCollectionsService,
    private alertsService: AlertsService,
    private languagesService: LanguagesService
  ) {}

  show(card: CollectionCard, callbackSaved?: () => void): void {
    this.callbackSaved = callbackSaved;
    this.cardId = card.cardId;
    this.name = card.name;
    this.rankType = card.rankType;
    this.translations = buildCollectionTranslationForms(this.languagesService.languages, card.translations);
    this.isLoading = false;
    this.modal.show();
  }

  save(): void {
    this.isLoading = true;
    this.apiCollectionsService.editCollectionAlbumCard(this.cardId, this.albumId, this.name, this.rankType, toCollectionTranslations(this.translations)).then(
      () => {
        this.isLoading = false;
        this.modal.hide();
        this.alertsService.displayAlertSuccess('Card updated !');
        if (this.callbackSaved) { this.callbackSaved(); }
      }, error => {
        this.isLoading = false;
        this.alertsService.displayAlertError('Error updating card : ' + error);
      }
    );
  }
}
